import ListSearchBar from "../ListSearchBar";
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable eqeqeq */
import { translate } from 'pdf-lib';
import React, { useEffect, useState } from 'react';
import { Button, Dropdown, Form, NavLink, Table } from 'react-bootstrap';
import ReactPaginate from 'react-paginate';
import { PropagateLoader } from 'react-spinners';
import { useTranslate } from '../../hooks/LanguageProvider';
import { DownloadModal, formatToTimestamp, generateExcelFile, generatePDFFile, handleDownloadConfirm, toTimestamp, useClipboard } from '../../utilities/functions';
import { toast } from 'react-toastify';
const backendUrl = process.env.REACT_APP_BACKEND_URL;

// Définition de l'interface pour les données de rapport
interface ReportData {
  id_repport: number;
  serial_number: string;
  machine_group: string;
  work_detail: string;
  department: string;
  requester: string;
  request_date: string;
  work_hours: number;
  park_hours: number;
  gps_working: number;
  gps_movement: number;
  private_hours: number;
  penalty_reason: string;
  supplier: string;
  unit_price: number;
  total_price: number;
  code_center: number;
  stop_time_minutes: number;
  running_time_minutes: number;
  idle_time_minutes: number;
  private_time_minutes: number;
  start: string;
  end: string;
  driver_name: string;
}

interface recapData {
  id_repport: number;
  type_report: number;
  turn_report: number;
  date_creation: string;
  date_debut: string;
  date_fin: string;
}

interface Report50Props {
  type_report?: string;
  turn?: string;
  id_report?: string;
}

const Report50: React.FC<Report50Props> = ({ type_report, turn, id_report }) => {

  const [sortConfig, setSortConfig] = useState<{ key: keyof ReportData; direction: 'ascending' | 'descending' } | null>(null);

  const user_id = localStorage.getItem("userid");
  const { translate } = useTranslate();
  const [Reports, setReports] = useState([]);
  const [recapReport, setRecapReport] = useState<recapData>();
  const [pageCount, setPageCount] = useState(0);
  let [total, setTotalPage] = useState(0);
  const [limit, setSelectedLimit] = useState(10);
  const [loading, setLoading] = useState(true);
  const [column, setSortColumn] = useState("id_repport");
  const [sort, setSort] = useState("ASC");
  const [search, setSearch] = useState("");
  const [type, setType] = useState(0);
  const [typeSearch, setTypeSearch] = useState(translate(translate("Report ID")));

  const [showDropdown, setShowDropdown] = useState<string>("");

  const [InputAdvancedSearch, setInputAdvancedSearch] = useState<string>("Vehicle");
  const [inputTypeSearch, setInputTypeSearch] = useState<number>(0);
  const [selectedReports, setSelectedReports] = useState<string[]>([]);
  const [selectAll, setSelectAll] = useState(false)
  const [isReportsSelected, setIsReportsSelected] = useState(false);
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const { copyToClipboard, copiedId } = useClipboard(translate("Matriculation Copied"));


  let page = 1;

  interface MenuItem {
    id: number;
    fieldName: string;
    label: string;
  }

  const MenuItems: MenuItem[] = [
    { id: 0, fieldName: translate('Vehicle'), label: translate('Vehicle') },
    { id: 1, fieldName: translate('Group'), label: translate('Vehicles group') },
    { id: 2, fieldName: 'PSN', label: 'PSN' },
    { id: 3, fieldName: translate('User'), label: translate('User') },
  ];



  const [selectedColumns, setSelectedColumns] = useState<{ [key: string]: boolean }>({
    id_repport: true,
    serial_number: true,
    machine_group: true,
    work_detail: true,
    department: true,
    requester: true,
    request_date: true,
    work_hours: true,
    park_hours: true,
    gps_working: true,
    gps_movement: true,
    private_hours: true,
    penalty_reason: true,
    supplier: true,
    unit_price: true,
    total_price: true,
    code_center: true,
  });

  const handleColumnChange = (column: string) => {
    setSelectedColumns((prevState: any) => ({
      ...prevState,
      [column]: !prevState[column],
    }));
  };

  const onDownloadConfirm = (format: string) => {
    if (selectedReports.length > 0) {
      handleDownloadConfirm(format, downloadVehicleExcel, downloadVehiclePDF);
    } else {
      toast.warn("Please select at least one vehicle", {
        position: "bottom-right",
        autoClose: 3000,
      });
    }
  };

  const vehicleHeaders = [
    translate("Serial Number With Machine Name"),
    translate("Group Of Machines"),
    // translate("Work Detail"),
    translate("Department"),
    translate("Requester"),
    translate("Date"),
    // translate("W.H"),
    translate("GPS Working"),
    translate("GPS Marche"),
    translate("GPS park"),
    // translate("Penalty Reason"),
    translate("Supplier"),
    // translate("Unit"),
    // translate("Price"),
    // translate("Total"),
    // translate("Price"),
    // translate("Code"),
    // translate("Center")
  ];






  const downloadVehicleExcel = () => {

    const selectedData = Reports.filter((reports: ReportData) =>
      selectedReports.includes(reports.id_repport.toString())
    ).map((reports: ReportData) => [
      reports.serial_number,
      reports.machine_group,
      // reports.work_detail,
      reports.department,
      reports.requester,
      reports.request_date,
      // reports.work_hours,
      // reports.park_hours,
      reports.gps_working,
      reports.gps_movement,
      reports.park_hours,
      // reports.private_hours,
      // reports.penalty_reason,
      reports.supplier,
      // reports.unit_price,
      // reports.total_price,
      // reports.code_center,
    ]);


    generateExcelFile(translate("List") + ' ' + translate("Vehicles"), vehicleHeaders, selectedData);
  };

  const downloadVehiclePDF = () => {

    const selectedData = Reports.filter((reports: ReportData) =>
      selectedReports.includes(reports.id_repport.toString())
    ).map((reports: ReportData) => [
      reports.serial_number,
      reports.machine_group,
      // reports.work_detail,
      reports.department,
      reports.requester,
      reports.request_date,
      // reports.work_hours,
      // reports.park_hours,
      reports.gps_working,
      reports.gps_movement,
      reports.park_hours,
      // reports.private_hours,
      // reports.penalty_reason,
      reports.supplier,
      // reports.unit_price,
      // reports.total_price,
      // reports.code_center,
    ]);
    generatePDFFile(translate("List") + ' ' + translate("Vehicles"), vehicleHeaders, selectedData);
  };



  const handleSortingColum = (currentColumn: string) => {

    const nextSort = sort === "ASC" ? "DESC" : "ASC";
    setSortColumn(currentColumn);
    setSort(nextSort);
    getReport(limit, page, search, type, currentColumn, nextSort);
  };


  const handleAdvancedSearch = async (event: any) => {
    const newValue = event.target.value;
    setSearch(newValue);
    page = 1;
    await getReport(limit, 1, newValue, type, column, sort);
  };


  const handlePageClick = async (data: any) => {
    page = data.selected + 1;
    const commentsFormServer = await getReport(limit, page, search, type, column, sort);
    setReports(commentsFormServer);
    window.scrollTo(0, 0)
  };

  const handleItemClick = (fieldId: number, fieldName: string) => {

    // console.log('Clicked on:', fieldName);

    setInputAdvancedSearch(fieldName);
    setInputTypeSearch(fieldId);
    setShowDropdown("");

  };


  // Function to handle the change in the select element
  const handleSelectChange = async (event: any) => {
    const newValue = event.target.value;
    setSelectedLimit(parseInt(newValue));
    const commentsFormServer = await getReport(limit, newValue, search, type, column, sort);

    setReports(commentsFormServer);

  };


  const getReport = async (
    limit: number,
    page: number,
    search: string,
    type: number,
    column: string,
    sort: string
  ) => {
    try {
      const bodyData = JSON.stringify({
        limit,
        page,
        search,
        type,
        turn, 
        column,
        sort,
      });

    
      const total_pages = await fetch(`${backendUrl}/api/report50/totalpage`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: bodyData,
        mode: "cors",
      });
  
      const totalPages = await total_pages.json();
      total = totalPages?.[0]?.total ?? 0;
      setTotalPage(total);
  
      const res = await fetch(`${backendUrl}/api/report50`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: bodyData,
        mode: "cors",
      });
  
      const data = await res.json();
      const reportData = Array.isArray(data?.reportData) ? data.reportData : [];
  
      setPageCount(Math.ceil(total / limit));
      setReports(reportData);
      setRecapReport(data?.recap ?? {});
  
      return reportData;
    } catch (error) {
      console.error("Erreur dans getReport:", error);
      return []; // retourne un tableau vide en cas d’erreur
    } finally {
      setLoading(false);
    }
  };
  

  useEffect(() => {



    getReport(limit, page, search, type, column, sort);

  }, [user_id, limit]);



  // Function to determine the background color based on the total score
  const getScoreClass = (score: number) => {
    if (score < 2) return 'table-success';
    if (score >= 2 && score < 5) return 'table-warning';
    if (score >= 5) return 'table-danger';
    return '';
  };
  const calculateDrivingTime = (drivingTime: number, hoursAuthorized: number) => {
    let drivingExceeded = 'D: 00h 00m 00s';
    let hosPenalty = 0;
    let positive = 0;

    if (drivingTime - hoursAuthorized > 0) {
      drivingExceeded = formatDuration((drivingTime - hoursAuthorized) * 60 * 60);
      hosPenalty = (drivingTime - hoursAuthorized) * 60 / 10;
      positive = 1;
    }

    return { hosPenalty, drivingExceeded, positive };
  };

  const calculateRestTime = (restTime: number, hoursAuthorized: number) => {
    let restExceeded = 'R: 00h 00m 00s';
    let hosPenalty = 0;
    let positive = 0;

    if (hoursAuthorized - restTime > 0) {
      restExceeded = formatDuration(restTime * 60 * 60);
      hosPenalty = restTime * 60 / 10;
      positive = 1;
    }

    return { hosPenalty, restExceeded, positive };
  };

  // Fonction pour formater la durée en 'Hh Mm Ss'
  const formatDuration = (seconds: number) => {
    const date = new Date(0);
    date.setSeconds(seconds); // spécifier la valeur en secondes
    return date.toISOString().substr(11, 8);
  };


  const handleTypeSearch = (selectedValue: string) => {
    let nextType = type;
    switch (selectedValue) {
      case translate("Serial Number With Machine Name"):
        nextType = 0;
        break;
      case translate("Group Of Machines"):
        nextType = 1;
        break;
      case translate("Work Detail"):
        nextType = 2;
        break;
      case translate("Department"):
        nextType = 3;
        break;
      case translate("Requester"):
        nextType = 4;
        break;
      case translate("Date"):
        nextType = 5;
        break;
      case translate("W.H"):
        nextType = 6;
        break;
      case translate("GPS Working"):
        nextType = 7;
        break;
      case translate("GPS Marche"):
        nextType = 8;
        break;
      case translate("GPS Park"):
        nextType = 9;
        break;
      case translate("Penalty Reason"):
        nextType = 10;
        break;
      case translate("Supplier"):
        nextType = 11;
        break;
      case translate("Unit Price"):
        nextType = 12;
        break;
      case translate("Total Price"):
        nextType = 13;
        break;
      case translate("Code Center"):
        nextType = 14;
        break;
      default:
        console.warn("Unknown selection:", selectedValue);
        break;
    }

    setType(nextType);
    setTypeSearch(selectedValue);
    page = 1;
    void getReport(limit, 1, search, nextType, column, sort);
  };


  const menuItems = [
    translate("Serial Number With Machine Name"),
    translate("Group Of Machines"),
    // translate("Work Detail"),
    translate("Department"),
    translate("Requester"),
    translate("Date"),
    // translate("W.H"),
    translate("GPS Working"),
    translate("GPS Marche"),
    translate("GPS Park"),
    // translate("Penalty Reason"),
    translate("Supplier"),
    // translate("Unit Price"),
    // translate("Total Price"),
    // translate("Code Center"),
  ];



  const handleResetSearch = async () => {

    setSearch("");
    page = 1;
    await getReport(limit, 1, "", type, column, sort);
  };
  const columns = [
    { key: "serial_number", label: "Serial Number With Machine Name" },
    { key: "machine_group", label: "Group Of Machines" },
    // { key: "work_detail", label: "Work Detail" },
    { key: "department", label: "Department" },
    { key: "requester", label: "Requester" },
    { key: "request_date", label: "Date" },
    // { key: "work_hours", label: "W.H" },
    { key: "gps_working", label: "GPS Working" },
    { key: "gps_movement", label: "GPS Marche" },
    { key: "park_hours", label: "GPS Park" },
    // { key: "penalty_reason", label: "Penalty Reason" },
    { key: "supplier", label: "Supplier" },
    // { key: "unit_price", label: "Unit Price" },
    // { key: "total_price", label: "Total Price" },
    // { key: "code_center", label: "Code Center" },
  ];


  // In the handleSelectAllDrivers function
  const handleSelectAllReports = (checked: boolean) => {
    setSelectAll(checked);
    // console.log(checked)
    if (checked) {
      // Select all POIs
      const allReportIDs = Reports.map((report: ReportData) => report.id_repport.toString()); // Convert to strings
      setSelectedReports(allReportIDs);
      setIsReportsSelected(true);// Mark as selected
    } else {
      // Select all POIs
      setSelectedReports([]);
      setIsReportsSelected(false); // Mark as unselected
    }
  };


  const handleReportsSelect = (ReportID: string) => {
    let updatedSelectedReports: string[] = [];

    // If "Select All Vehicles" is enabled, selects or deselects all vehicles
    if (selectAll) {
      updatedSelectedReports = selectedReports.includes(ReportID)
        ? selectedReports.filter(id => id !== ReportID) //Deselect if already selected
        : Reports.map((report: ReportData) => report.id_repport.toString()); // Select all vehicles
    } else {
      //Managing selection/normal selection of an individual vehicle
      if (selectedReports.includes(ReportID)) {
        updatedSelectedReports = selectedReports.filter(id => id !== ReportID);
      } else {
        updatedSelectedReports = [...selectedReports, ReportID];
      }
    }

    // Updates the list of selected vehicles
    setSelectedReports(updatedSelectedReports);

    // Updates the Vehicles Selected state (activate if at least one is selected)
    setIsReportsSelected(updatedSelectedReports.length > 0);

    // console.log(updatedSelectedVehicles);
  };



  return (
    <>
      <div className="row">
        <div className="col-sm-6 col-md-6">
          <h6>
            <i className="las la-chart-bar" data-rel="bootstrap-tooltip" title="Increased"></i> {translate("Driver behavior")}  {' '}
            Nr.Tournée: {recapReport?.turn_report},  Du{' '}
            <span style={{ color: '#3468C0' }}>{toTimestamp(recapReport?.date_debut ?? '')}</span>
            {' '}  au {' '}
            <span style={{ color: '#3468C0' }}>{toTimestamp(recapReport?.date_fin ?? '')}</span>
          </h6>
        </div>
        <div className="col-sm-6 col-md-6 " >
          <div id="DataTables_Table_0_filter" className="float-right dataTables_filter mr-3">


            <button
              className="btn btn-outline-secondary mr-1"
              onClick={() => setShowDownloadModal(true)}
            >
              <i className="las la-download"></i>
              {translate("Export")}
            </button>
          </div>
        </div>
      </div>
      <div>
        <div className="row m-2">
          <div className="col-sm-6 col-md-6 list-search-column" style={{ margin: "0px 0px 10px 0px", padding: "0px" }}>

            <ListSearchBar criteria={<Dropdown>
                <Dropdown.Toggle variant="link" id="dropdown-basic" >{translate(typeSearch)}</Dropdown.Toggle>
                <Dropdown.Menu>
                  {menuItems.map((item, index) => (
                    <Dropdown.Item
                      key={index}
                      onClick={() => handleTypeSearch(item)}
                      eventKey={item}
                      active={typeSearch === item}
                      className={typeSearch === item ? "select-active" : ""}
                    >
                      {item}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>} onReset={handleResetSearch} resetLabel={translate("Reset search")}>
<input type="text" value={search} placeholder={` ${translate("Search by")} ${translate(typeSearch)}`} onChange={handleAdvancedSearch} className="form-control" />
</ListSearchBar>
          </div>
          <div className="col-md-6 d-flex justify-content-end align-items-center">
            <div className="dataTables_length" id="DataTables_Table_0_length">
              <label style={{ float: "right" }}>
                {translate('Show')}
                <select
                  name="DataTables_Table_0_length"
                  aria-controls="DataTables_Table_0"
                  className="custom-select custom-select-sm form-control form-control-sm mr-2 ml-2"
                  style={{ width: "66px" }}
                  onChange={handleSelectChange}
                >
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                  <option value="200">200</option>
                  <option value="500">500</option>
                </select>
              </label>
            </div>
            <Dropdown>
              <Dropdown.Toggle
                variant=""
                id="dropdown-basic"
                title={translate("Display columns")}
              >
                <i className="las la-eye"></i>
              </Dropdown.Toggle>


              <Dropdown.Menu>
                {columns.map(({ key, label }) => (
                  <Dropdown.Item key={key} as="button" style={{ display: "flex", alignItems: "center" }}>
                    <input
                      type="checkbox"
                      className="form-check-input"
                      checked={selectedColumns[key]}
                      onChange={() => handleColumnChange(key)}
                    />
                    <span style={{ marginLeft: "10px" }}>{translate(label)}</span>
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>

            </Dropdown>

          </div>

        </div>
        <div className="row m-1 table-responsive">
          <Table className="dataTable">
            <thead className="bg-white">
              <tr>
                <th>
                  <div className="checkbox d-inline-block">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={selectAll}
                      onChange={(e) => handleSelectAllReports(e.target.checked)}
                    />
                    <label className="form-check-label"></label>
                  </div>
                </th>
                {selectedColumns.serial_number && (
                  <th className="sorting" style={{ textAlign: "left", minWidth: "200px" }} onClick={() => handleSortingColum("serial_number")}>
                    {translate("Serial Number With Machine Name")}
                  </th>
                )}
                {selectedColumns.machine_group && (
                  <th className="sorting" style={{ textAlign: "left" }} onClick={() => handleSortingColum("machine_group")}>
                    {translate("Group Of Machines")}
                  </th>
                )}
                {/* {selectedColumns.work_detail && (
                  <th className="sorting" style={{ textAlign: "left" }} onClick={() => handleSortingColum("work_detail")}>
                    {translate("Work Detail")}
                  </th>
                )} */}
                {selectedColumns.department && (
                  <th className="sorting" style={{ textAlign: "left" }} onClick={() => handleSortingColum("department")}>
                    {translate("Department")}
                  </th>
                )}
                {selectedColumns.requester && (
                  <th className="sorting" style={{ textAlign: "left" }} onClick={() => handleSortingColum("requester")}>
                    {translate("Requester")}
                  </th>
                )}
                {selectedColumns.request_date && (
                  <th className="sorting" style={{ textAlign: "left" }} onClick={() => handleSortingColum("request_date")}>
                    {translate("Date")}
                  </th>
                )}
                {/* {selectedColumns.work_hours && (
                  <th className="sorting" style={{ textAlign: "left" }} onClick={() => handleSortingColum("work_hours")}>
                    {translate("W.H")}
                  </th>
                )} */}
                {selectedColumns.gps_working && (
                  <th className="sorting" style={{ textAlign: "left" }} onClick={() => handleSortingColum("gps_working")}>
                    {translate("GPS Working")}
                  </th>
                )}
                {selectedColumns.gps_movement && (
                  <th className="sorting" style={{ textAlign: "left" }} onClick={() => handleSortingColum("gps_movement")}>
                    {translate("GPS Marche")}
                  </th>
                )}
                {selectedColumns.park_hours && (
                  <th className="sorting" style={{ textAlign: "left" }} onClick={() => handleSortingColum("park_hours")}>
                    {translate("GPS park")}
                  </th>
                )}
                {/* {selectedColumns.penalty_reason && (
                  <th className="sorting" style={{ textAlign: "left" }} onClick={() => handleSortingColum("penalty_reason")}>
                    {translate("Penalty Reason")}
                  </th>
                )} */}
                {selectedColumns.supplier && (
                  <th className="sorting" style={{ textAlign: "left" }} onClick={() => handleSortingColum("supplier")}>
                    {translate("Supplier")}
                  </th>
                )}
                {/* {selectedColumns.unit_price && (
                  <th className="sorting" style={{ textAlign: "left" }} onClick={() => handleSortingColum("unit_price")}>
                    {translate("Unit Price")}
                  </th>
                )} */}
                {/* {selectedColumns.total_price && (
                  <th className="sorting" style={{ textAlign: "left" }} onClick={() => handleSortingColum("total_price")}>
                    {translate("Total Price")}
                  </th>
                )}
                {selectedColumns.code_center && (
                  <th className="sorting" style={{ textAlign: "left" }} onClick={() => handleSortingColum("code_center")}>
                    {translate("Code Center")}
                  </th>
                )} */}

              </tr>

            </thead>
            <tbody>
              {loading ? (
                <tr style={{ textAlign: "center" }}>
                  <td className="text-center" colSpan={10}>
                    <p>
                      <PropagateLoader color={"#123abc"} loading={loading} size={20} />
                    </p>
                  </td>
                </tr>
              ) : Reports.length > 0 ? (
                Reports.map((report: ReportData) => {
                  return (
                    <tr key={report.id_repport} role="row">
                      <td>
                        <div className="checkbox d-inline-block">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id={`checkbox-${report.id_repport}`}
                            checked={selectedReports.includes(report.id_repport.toString())}
                            onChange={() => handleReportsSelect(report.id_repport.toString())}
                          />
                          <label htmlFor={`checkbox-${report.id_repport}`} className="mb-0"></label>
                        </div>
                      </td>
                      {selectedColumns.serial_number && <td
                        id={`vehicle-${report.id_repport}`}
                        style={{ cursor: 'pointer', position: 'relative', color: copiedId === report.id_repport.toString() ? '#28a745' : '#007bff' }}
                        title={translate("Click to copy the registration matriculation")}
                        onClick={() => {
                          if (report.serial_number && report.id_repport.toString()) {
                            copyToClipboard(report.serial_number, report.id_repport.toString());
                          }
                        }} >{
                          <>
                            <span style={{ color: copiedId === report.id_repport.toString() ? '#28a745' : '#007bff' }}>
                              {report.serial_number}
                            </span>

                            {copiedId === report.id_repport.toString() && (
                              <span
                                style={{
                                  position: 'absolute',
                                  top: '-20px',
                                  left: '50%',
                                  transform: 'translateX(-50%)',
                                  backgroundColor: '#28a745',
                                  color: '#fff',
                                  padding: '2px 5px',
                                  borderRadius: '4px',
                                  fontSize: '12px',
                                }}
                              >
                                {translate("Matriculation Copied")}
                              </span>
                            )}
                          </>
                        }
                      </td>}
                      {selectedColumns.machine_group && <td>{report.machine_group}</td>}
                      {/* {selectedColumns.work_detail && <td>{report.work_detail}</td>} */}
                      {selectedColumns.department && <td>{report.department}</td>}
                      {selectedColumns.requester && <td>{report.requester}</td>}
                      {selectedColumns.request_date && <td>{report.request_date ? report.request_date.split("T")[0] : ""}</td>}
                      {/* {selectedColumns.work_hours && <td>{""}</td>} */}
                      {selectedColumns.gps_working && <td>{report.gps_working}</td>}
                      {selectedColumns.gps_movement && <td>{report.gps_movement}</td>}
                      {selectedColumns.park_hours && <td>{report.park_hours}</td>}
                      {/* {selectedColumns.park_hours && <td>{""}</td>} */}
                      {/* {selectedColumns.penalty_reason && <td>{""}</td>} */}
                      {selectedColumns.supplier && <td>{report.supplier}</td>}
                      {/* {selectedColumns.unit_price && <td>{report.unit_price}</td>}
                      {selectedColumns.total_price && <td>{report.total_price}</td>}
                      {selectedColumns.code_center && <td>{report.code_center}</td>} */}
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={10}>No report available</td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>

      <div className="row">
        <div className="col-md-6 d-flex align-items-center">
          <span>
            {translate("Displaying")} {Reports.length} {translate("on")}{" "}
            {total}
          </span>
        </div>
        <div className="col-md-6 d-flex justify-content-end">
          <ReactPaginate
            previousLabel={translate("previous")}
            nextLabel={translate("next")}
            breakLabel={"..."}
            pageCount={pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={3}
            onPageChange={handlePageClick}
            containerClassName={"pagination justify-right"}
            pageClassName={"page-item"}
            pageLinkClassName={"page-link"}
            previousClassName={"page-item"}
            previousLinkClassName={"page-link"}
            nextClassName={"page-item"}
            nextLinkClassName={"page-link"}
            breakClassName={"page-item"}
            breakLinkClassName={"page-link"}
            activeClassName={"active"}
          />
        </div>
        <DownloadModal
          show={showDownloadModal}
          onHide={() => setShowDownloadModal(false)}
          onDownloadConfirm={onDownloadConfirm}
        />
      </div>
    </>
  );
}

export default Report50;
